import $ from 'jquery';
import React from 'react';
import { isMobile } from '../../../../constants/Constants';
import { validateField, removeLocalStorage } from '../../../../helpers/tools';
import { validate } from '../../../../helpers/adRullesValidators';
import AdBreakSet from './AdBreakSet';

class AdRule extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      key: Math.random(),
      isDurationValid: true,
      isPrerollsValid: validate(this.props.data.data.prerolls, 'prerolls', null),
      isMidrollsValid:
        this.props.data.data.midrolls && this.props.data.data.midrolls.instances !== 0
          ? validate(this.props.data.data.midrolls, 'midrolls', null)
          : true,
      isPostrollsValid: validate(this.props.data.data.postrolls, 'postrolls', null),
      isOverlaysValid:
        this.props.data.data.overlays && this.props.data.data.overlays.instances !== 0
          ? validate(this.props.data.data.overlays, 'overlays', null)
          : true,
    };
  }

  componentDidMount() {
    $($('input[name="minDur"]')[this.props.index]).on('blur', this.validateMinDuration);
    $($('input[name="maxDur"]')[this.props.index]).on('blur', this.validateMaxDuration);

    this.adBreakValidationUpdate();
  }

  componentDidUpdate(prevProps) {
    $($('input[name="minDur"]')[this.props.index]).off('blur', this.validateMinDuration);
    $($('input[name="maxDur"]')[this.props.index]).off('blur', this.validateMaxDuration);

    $($('input[name="minDur"]')[this.props.index]).on('blur', this.validateMinDuration);
    $($('input[name="maxDur"]')[this.props.index]).on('blur', this.validateMaxDuration);

    if (JSON.stringify(prevProps.data) !== JSON.stringify(this.props.data)) {
      this.adBreakValidationUpdate();
    }
  }

  adBreakValidationUpdate = function () {
    const isPrerollsValid = validate(this.props.data.data.prerolls, 'prerolls', null);
    const isMidrollsValid =
      this.props.data.data.midrolls && this.props.data.data.midrolls.instances !== 0
        ? validate(this.props.data.data.midrolls, 'midrolls', null)
        : true;
    const isPostrollsValid = validate(this.props.data.data.postrolls, 'postrolls', null);
    const isOverlaysValid =
      this.props.data.data.overlays && this.props.data.data.overlays.instances !== 0
        ? validate(this.props.data.data.overlays, 'overlays', null)
        : true;
    const isValid =
      this.state.isDurationValid &&
      isPrerollsValid &&
      isMidrollsValid &&
      isPostrollsValid &&
      isOverlaysValid;

    this.setState({
      isPrerollsValid: isPrerollsValid,
      isMidrollsValid: isMidrollsValid,
      isPostrollsValid: isPostrollsValid,
      isOverlaysValid: isOverlaysValid,
    });

    if (this.props.isValid !== isValid) {
      this.props.updateState({ isValid: isValid });
    }
  };

  /**
   * Method to open the pop up for an ad break
   * @param {event} event
   */
  adBreakBtnClick = event => {
    let adBreakBtn = event.target,
      adBreakPopUp = $(adBreakBtn.parentNode.parentNode).find('.adBreakPopUp'),
      adBreakPopUpClose = e => {
        let popUp = e.data.popUp;

        if (!popUp.find(e.target).length && popUp[0] !== e.target) {
          popUp.removeClass('active');
          $('.pluginSettingsSection').css('overflow', '');
          popUp.find('.applyBtn').text('Apply');
          popUp.find('.applyBtn').removeClass('applied');
          $(document).off(isMobile ? 'touchend' : 'mousedown', adBreakPopUpClose);

          this.setState({
            key: Math.random(),
          });
        }
      };

    $('.pluginSettingsSection').css('overflow', 'hidden');
    adBreakPopUp.addClass('active');
    adBreakPopUp.trigger('executeValidationOnPopup');

    if (adBreakPopUp.css('position') === 'absolute') {
      /**
       * "43" is the constant value needed to the perfect centring of a ad break pop up.
       * I think it can be calculated somehow by adding padding values, borders etc.
       */
      adBreakPopUp.css(
        'transform',
        'translate(' +
          Math.ceil(
            $(adBreakBtn).width() +
              Number.parseInt($(adBreakBtn.parentNode).css('margin-left'), 10) +
              $(adBreakBtn).offset().left -
              $(adBreakBtn.parentNode).offset().left
          ) +
          'px, ' +
          (-adBreakPopUp.height() / 2 - $('.pluginSettingsSection').scrollTop() - 43) +
          'px)'
      );
    } else {
      adBreakPopUp.css('top', 'calc(50% - ' + adBreakPopUp.height() / 2 + 'px)');
    }

    $(document).on(isMobile ? 'touchend' : 'mousedown', { popUp: adBreakPopUp }, adBreakPopUpClose);
  };

  /**
   * Method to remove an ad rule
   */
  removeAdRuleAction = () => {
    this.setState({
      key: Math.random(),
    });

    let isValid = true;
    this.props.removeAdRuleAction(this.props.index);

    setTimeout(() => {
      const items = $('.settingsInputs .validationError').toArray();
      for (const item of items) {
        if ($(item).is(':visible')) {
          isValid = false;
          break;
        }
      }

      this.setState({ isDurationValid: isValid });
      this.props.updateState({ isValid: isValid });
    }, 0);

    try {
      removeLocalStorage('AdBreakRow' + this.props.index);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('Error while local storage was clearing');
    }
  };

  /**
   * Method to check that all fields from form are valid and we can start test
   */
  updateState = () => {
    const min = $('input[name=minDur]');
    const max = $('input[name=maxDur]');

    let data = {
      adRule: {
        duration_min:
          min && min.length
            ? Number.parseInt(min[this.props.index].value, 10)
            : this.props.data.duration_min,
        duration_max:
          max && max.length
            ? Number.parseInt(max[this.props.index].value, 10)
            : this.props.data.duration.max,
        data: this.props.data.data,
      },
      index: this.props.index,
      isValid: true,
    };

    const items = $('.validationError').toArray();
    for (const item of items) {
      const display = $(item).css('display');
      if (display === 'block' || display === 'table-column') {
        data.isValid = false;
        break;
      }
    }

    this.setState({ isDurationValid: data.isValid });
    this.props.updateState(data);
  };

  /**
   * Method to validate minimum duration field
   * @param {event} event
   */
  validateMaxDuration = (event, triggered) => {
    if (triggered) {
      event.preventDefault();
      event.triggered = true;
    }

    let minValueInput = $(event.target.parentNode.parentNode).find('input[name=minDur]'),
      minValue = Number.parseInt(minValueInput[0].value, 10);

    if (minValue > -1) {
      minValueInput.parent().find('.validationError').hide();
      minValueInput.removeClass('textFiledError');
    }

    if (Number.parseInt(event.target.value, 10) < 0 || Number.isNaN(minValue)) {
      minValue = -1;
    }

    validateField(event, 'number', true, this.updateState, minValue);
  };

  /**
   * Method to validate minimum duration field
   * @param {event} event
   */
  validateMinDuration = (event, triggered) => {
    if (triggered) {
      event.preventDefault();
      event.triggered = true;
    }

    let maxValueInput = $(event.target.parentNode.parentNode).find('input[name=maxDur]'),
      maxValue = Number.parseInt(maxValueInput[0].value, 10);

    if (maxValue > -2) {
      maxValueInput.parent().find('.validationError').hide();
      maxValueInput.removeClass('textFiledError');
    }

    if (maxValue < 0 || Number.isNaN(maxValue)) {
      maxValue = null;
    }

    validateField(event, 'number', true, this.updateState, 0, maxValue);
  };

  render() {
    return (
      <div className="adRule">
        <div>
          <h3>Client side</h3>
          <div className="inputsRow">
            <div className="labelHolder">
              <div className="smallInput">
                <label>Min duration</label>
              </div>
              <div className="smallInput">
                <label>Max duration</label>
              </div>
            </div>
            <div className="smallInput">
              <input
                type="number"
                name="minDur"
                className="textFiled"
                defaultValue={this.props.data.duration_min}
                key={
                  typeof this.props.data.duration_min === 'number'
                    ? this.props.data.duration_min
                    : 'duration_min_empty'
                }
                min="0"
              />
              <div className="validationError"></div>
            </div>
            <div className="smallInput">
              <input
                type="number"
                name="maxDur"
                className="textFiled"
                defaultValue={this.props.data.duration_max}
                key={
                  typeof this.props.data.duration_max === 'number'
                    ? this.props.data.duration_max
                    : 'duration_max_empty'
                }
                min="-1"
              />
              <div className="validationError"></div>
            </div>
          </div>
          <div>
            <div className="adBreakRow">
              <AdBreakSet
                onClick={this.adBreakBtnClick}
                btnClassName="prerollsBtn"
                labelText="Prerolls"
                adBreak={this.props.data.data.prerolls}
                popupType="prerolls"
                popupIndex={this.props.index}
                popupKey={this.state.key}
                isValid={this.state.isPrerollsValid}
              />
              <AdBreakSet
                onClick={this.adBreakBtnClick}
                btnClassName="midrollsBtn"
                labelText="Midrolls"
                adBreak={this.props.data.data.midrolls}
                popupType="midrolls"
                popupIndex={this.props.index}
                popupKey={this.state.key}
                isValid={this.state.isMidrollsValid}
              />
              <AdBreakSet
                onClick={this.adBreakBtnClick}
                btnClassName="postrollsBtn"
                labelText="Postrolls"
                adBreak={this.props.data.data.postrolls}
                popupType="postrolls"
                popupIndex={this.props.index}
                popupKey={this.state.key}
                isValid={this.state.isPostrollsValid}
              />
            </div>
            <div className="adBreakRow">
              <AdBreakSet
                onClick={this.adBreakBtnClick}
                btnClassName="overlaysBtn"
                labelText="Overlays"
                adBreak={this.props.data.data.overlays}
                popupType="overlays"
                popupIndex={this.props.index}
                popupKey={this.state.key}
                isValid={this.state.isOverlaysValid}
              />
            </div>
          </div>
        </div>
        <div className="removeAdRule" onClick={() => this.removeAdRuleAction()}></div>
      </div>
    );
  }
}

export default AdRule;
